import 'core-js'
import 'intersection-observer'
import _animate from '/src/_animate'
import animationData from './data.json'

const el = document.querySelector('#canvas_businessmodel')

_animate(el, 'businessmodel', animationData)
